import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const initState = {
  xmlReportName: "",
  status:'',
  description:""
};

export const addEditXMLReportsFormConfig = {
  name: "Report Type Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic User Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "xMLReportName",
          label: "Name",
          Field_Name: "name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "xmlReportName",
          fieldSetting: {
            placeholder: "Please enter name",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 col-12",
          },
        },
        {
          id: "reportTemplateID",
          label: "Report Template",
          Field_Name: "report template",
          fieldType: FormFieldTypes.SELECT,
          dataField: "reportTemplateID",
          fieldSetting: {
            placeholder: "Please select report template",
             allowSpace: true,
            isDisable: false,
            options:[],
          },          style: {
            containerCss: "col-lg-6 col-md-6 col-12",
          },
        },
        {
          id: "xmlTemplateId",
          label: "XML Template",
          Field_Name: "XML template",
          fieldType: FormFieldTypes.SELECT,
          dataField: "xmlTemplateId",
          fieldSetting: {
            placeholder: "Please select XML template",
             allowSpace: true,
            isDisable: false,
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 col-12",
          },
        },
        
        {
          id: "description",
          label: "Description",
          Field_Name: "description",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "description",
          fieldSetting: {
            placeholder: "Please enter description",
             allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 col-12",
          },
        },
        {
          id: "status",
          label: "Active",
          Field_Name: "Active",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "status",
          fieldSetting: {
            hasMainTitle: " ",
            placeholder: "  ",
          },
          style: {
            containerCss: "col-lg-2 col-md-2 col-12 checkbox-sec",
          },
        },
        
      ],
    },
  ],
};
